import { useTranslation } from '@dreamstack/i18n'
import { ArrowRight } from '@dreamstack/icons/src/icon-components/ArrowRight'
import { assertPopulated } from '@dreamstack/payload/src/lib/assertPopulated'
import { NewsArticle } from '@dreamstack/payload/src/payload-types'
import { motion } from 'framer-motion'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import {
  AnimateIconTranslationRight,
  useAnimateIconTranslationRight,
} from '../layout/AnimateIconTranslation'
import { NewsArticleFile } from './NewsArticleFile'

const baseLinkClasses =
  'flex items-center font-semibold text-px-16 leading-px-24 ml:(text-px-20 leading-px-30)'

const computeLinkClasses = (white?: boolean) =>
  [
    white
      ? 'text-accentroWhite-full mt-px-6'
      : 'text-accentroAqua-full mt-px-32',
    baseLinkClasses,
  ].join(' ')

export const ContinueReadingLink: FunctionComponent<
  React.PropsWithChildren<{
    whiteText?: boolean
    href: string
    file?: NewsArticle['file']
    onClick?: () => void
  }>
> = ({ whiteText, href, file, onClick }) => {
  assertPopulated(file)
  const t = useTranslation()
  const { controls, onHoverStart } = useAnimateIconTranslationRight()
  return (
    <>
      {!!file ? (
        <NewsArticleFile file={file} whiteText={whiteText} />
      ) : (
        <Link href={href} passHref legacyBehavior>
          <motion.a
            onClick={onClick}
            onHoverStart={onHoverStart}
            className={computeLinkClasses(!!whiteText)}
          >
            {t('accentro:continueReading')}{' '}
            <AnimateIconTranslationRight animate={controls}>
              <ArrowRight className="w-px-32 h-px-32 ml-px-12" />
            </AnimateIconTranslationRight>
          </motion.a>
        </Link>
      )}
    </>
  )
}
